module.exports = __webpack_public_path__ + "static/interior_off_left_s-a19beb9a50ed9cd3cdb1589aafd2cfae.webp";